module.exports = __webpack_public_path__ + "assets/lawandorder-6.29868774.svg";